
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import ReactApexChart from "react-apexcharts";
import { getDashboard } from '../../Service/Dashboard';
import { ParseDecimal } from '../../Components/CurrencyInput/ParseDecimal';
import { NumberFormat } from '../../Components/NumberFormat';
import moment from 'moment';

function HomePage() {
    const [dashboard, setDashboard] = useState({
        pending: 0,
        annual: 0,
        monthly: 0,
        so: 0,
        po: 0
    })
    const [pie, setpie] = useState({
        series: [],
        options: {
            chart: {
                width: 380,
                type: 'pie',
                id: 'pie1'
            },
            dataLabels: {
             enabled: true
            },
            labels: ['Closed', 'Open', 'Reject', 'Approve', 'Pending'],
            responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
            }],
            dataLabels: {
                enabled: true,
            }
        },
      
      
      }); 
    const [chartData, setChartData] = useState({
        series: [{
            data: []
          }],
        options: {
            chart: {
              height: 350,
              type: 'area',
              id: 'chart1'
            },
            stroke: {
              width: 5,
              curve: 'straight'
            },
            xaxis: {
                type: 'category',
                categories: [],
            },
            yaxis: {
                labels: {
                  formatter: function (value) {
                    return NumberFormat(value);
                  }
                },
              },
            // fill: {
            //   type: 'gradient',
            //   gradient: {
            //     shade: 'dark',
            //     gradientToColors: [ '#FDD835'],
            //     shadeIntensity: 1,
            //     type: 'horizontal',
            //     opacityFrom: 1,
            //     opacityTo: 1,
            //     stops: [0, 100, 100, 100]
            //   },
            // },
        },
    });

    useEffect(()=>{
        let labels_pie = [];
        let series_pie = [];
        let options_pie = pie.options;
        
        let label_chart = [];
        let series_chart = [];
        let options_chart = chartData.options;

        getDashboard({}).then(res => {
            let _dash = res.data.data;
            for(const row in _dash.pieChart){
                labels_pie.push(row);
                series_pie.push(_dash.pieChart[row])
            }
            for(const row in _dash.graphDay){
                label_chart.push(moment(_dash.graphDay[row].so_month).format('DD/MM/YYYY'));
                series_chart.push(Math.round(_dash.graphDay[row].totalDetail))
            }
            options_pie.labels = labels_pie;

            setDashboard({...dashboard, pending: _dash.soPending, annual: _dash.soCloseYear, monthly: _dash.soCloseMonth, so: _dash.soNowMonth})
            setpie({...pie,series: series_pie, options: options_pie })

            const newSeries = [];
            newSeries.push({ data: series_chart, name: "Earning" });
            setChartData({
                series: newSeries,
                options: { ...chartData.options, 
                    // labels: label_chart, 
                    xaxis: { ...chartData.options.xaxis, categories: label_chart } }
            });

        })
    },[])

    return (
        <div className="content-wrapper">
            <div className="row">
                <div className="col-lg-12">
                    <h2 className="page-title" style={{paddingLeft: 25}}>Welcome to Modena Retail</h2>
                </div>
                
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div className="row">

                        <div className="col-xl-3 col-md-6 mb-4">
                            <div className="card border-left-primary shadow h-100 py-2">
                                <div className="card-body">
                                    <div className="row no-gutters align-items-center">
                                        <div className="col mr-2">
                                            <div className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                                                Sales (Monthly)</div>
                                            <div className="h5 mb-0 font-weight-bold text-gray-800">{NumberFormat(ParseDecimal(dashboard.monthly))}</div>
                                        </div>
                                        <div className="col-auto">
                                            <i className="fas fa-calendar fa-2x text-gray-300"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-6 mb-4">
                            <div className="card border-left-success shadow h-100 py-2">
                                <div className="card-body">
                                    <div className="row no-gutters align-items-center">
                                        <div className="col mr-2">
                                            <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                                                Sales (Annual)</div>
                                            <div className="h5 mb-0 font-weight-bold text-gray-800">{NumberFormat(dashboard.annual)}</div>
                                        </div>
                                        <div className="col-auto">
                                            <i className="fas fa-dollar-sign fa-2x text-gray-300"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-3 col-md-6 mb-4">
                            <div className="card border-left-info shadow h-100 py-2">
                                <div className="card-body">
                                    <div className="row no-gutters align-items-center">
                                        <div className="col mr-2">
                                            <div className="text-xs font-weight-bold text-info text-uppercase mb-1">Sales Order
                                            </div>
                                            <div className="row no-gutters align-items-center">
                                                <div className="col-auto">
                                                    <div className="h5 mb-0 mr-3 font-weight-bold text-gray-800">{dashboard.so}</div>
                                                </div>
                                               
                                            </div>
                                        </div>
                                        <div className="col-auto">
                                            <i className="fas fa-clipboard-list fa-2x text-gray-300"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-3 col-md-6 mb-4">
                            <div className="card border-left-warning shadow h-100 py-2">
                                <div className="card-body">
                                    <div className="row no-gutters align-items-center">
                                        <div className="col mr-2">
                                            <div className="text-xs font-weight-bold text-warning text-uppercase mb-1">
                                                Pending Requests</div>
                                            <div className="h5 mb-0 font-weight-bold text-gray-800">{dashboard.pending}</div>
                                        </div>
                                        <div className="col-auto">
                                            <i className="fas fa-comments fa-2x text-gray-300"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xl-7 col-lg-12">
                            <div className="card shadow mb-4">
                                <div
                                    className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                                    <h6 className="m-0 font-weight-bold text-primary">Earnings Overview (Monthly)</h6>
                                    <div className="dropdown no-arrow">
                                        <a className="dropdown-toggle" href="#" role="button" id="dropdownMenuLink"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <i className="fas fa-ellipsis-v fa-sm fa-fw text-gray-400"></i>
                                        </a>
                                        <div className="dropdown-menu dropdown-menu-right shadow animated--fade-in"
                                            aria-labelledby="dropdownMenuLink">
                                            <div className="dropdown-header">Dropdown Header:</div>
                                            <a className="dropdown-item" href="#">Action</a>
                                            <a className="dropdown-item" href="#">Another action</a>
                                            <div className="dropdown-divider"></div>
                                            <a className="dropdown-item" href="#">Something else here</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="chart-area" id="chart">
                                        <ReactApexChart options={chartData.options} series={chartData.series} type="area" height={320} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-5 col-lg-6">
                            <div className="card shadow mb-4">
                                <div
                                    className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                                    <h6 className="m-0 font-weight-bold text-primary">Sales Status (Monthly)</h6>
                                    <div className="dropdown no-arrow">
                                        <a className="dropdown-toggle" href="#" role="button" id="dropdownMenuLink"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <i className="fas fa-ellipsis-v fa-sm fa-fw text-gray-400"></i>
                                        </a>
                                        <div className="dropdown-menu dropdown-menu-right shadow animated--fade-in"
                                            aria-labelledby="dropdownMenuLink">
                                            <div className="dropdown-header">Dropdown Header:</div>
                                            <a className="dropdown-item" href="#">Action</a>
                                            <a className="dropdown-item" href="#">Another action</a>
                                            <div className="dropdown-divider"></div>
                                            <a className="dropdown-item" href="#">Something else here</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="chart-pie pt-4 pb-2" >
                                        <ReactApexChart options={pie.options} series={pie.series} type="pie" width={350} />
                                    </div>
                                    <div className="mt-4 text-center small">
                                        <span className="mr-2">
                                            {/* <i className="fas fa-circle text-primary"></i> Direct */}
                                        </span>
                                        <span className="mr-2">
                                            {/* <i className="fas fa-circle text-success"></i> Social */}
                                        </span>
                                        <span className="mr-2">
                                            {/* <i className="fas fa-circle text-info"></i> Referral */}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default HomePage